import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { Company } from '@core/models/company';
import { MixpanelService } from '@core/services/mixpanel.service';
import { DeviceDetectorService } from "ngx-device-detector";
import { ModalUtilsService } from 'src/app/services/modal-utils.service';

type ProgressButtonStyle = {
  background?: string;
}

type IconContainerStyle = {
  height?: string;
  width?: string;
}

@Component({
  selector: 'bpc-spreadsheet-download',
  templateUrl: './spreadsheet-download.component.html',
})
export class SpreadsheetDownloadComponent {

  progressButtonStyle: ProgressButtonStyle = {}
  iconContainerStyle: IconContainerStyle = {}

  constructor(
    public deviceDetectorService: DeviceDetectorService,
    private mixpanelService: MixpanelService,
    private modalUtilsService: ModalUtilsService,
  ) {
    this.iconContainerStyle.height = 'calc(100% - 0.25rem)';
    this.iconContainerStyle.width = 'calc(100% - 0.25rem)';
  }

  onButtonClick() {
    this.mixpanelService.trackEvent('Download_Voting_Spreadsheet');
    let modalParameters = this.modalUtilsService.modalParameters;
    modalParameters.currentModalAction = "downloadVotingSpreadsheet";
    this.modalUtilsService.toggalModal.next(modalParameters);
  }

  get isTablet(): boolean {
    return this.deviceDetectorService.isTablet();
  }
}
